import { Component, AfterViewInit, Input } from '@angular/core';
import { IMapLocationData } from '../../models';
import { environment } from '../../../environments';

declare const google: any;  // Added declaration

@Component({
    selector: 'app-google-map',
    imports: [],
    templateUrl: './google-map.component.html',
    styleUrl: './google-map.component.scss'
})
export class GoogleMapComponent implements AfterViewInit {

  @Input() mapLocationData: IMapLocationData[] = [];

  ngAfterViewInit(): void {
    (window as typeof window & { initMap: () => void }).initMap = this.initMap.bind(this);

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleApiKey}&libraries=places&callback=initMap`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  initMap(): void {
    if (!this.mapLocationData.length) {
      // console.warn('No location data available.');
      return;
    }

    const map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
      center: { 
        lat: this.mapLocationData[0].latitude, 
        lng: this.mapLocationData[0].longitude 
      },
      zoom: 12
    });

    const infoWindow = new google.maps.InfoWindow(); // Single InfoWindow instance for all markers

    // Iterate over the location data to create markers
    this.mapLocationData.forEach(location => {
      const marker = new google.maps.Marker({
        position: { lat: location.latitude, lng: location.longitude },
        map,
        title: location.label || 'Location'
      });

      // Info Window on marker click (shows address or custom content)
      marker.addListener('click', () => {
        infoWindow.setContent(`
          <div>
            <p class="fw-bold">${location.label || 'Location Details'}</h6>
            <p><strong>Latitude:</strong> ${location.latitude}</p>
            <p><strong>Longitude:</strong> ${location.longitude}</p>
          </div>
        `);
        infoWindow.open(map, marker);
      });
    });
  }
}
